module.exports = __webpack_public_path__ + "img/icon_map_188_on_111.62a7c79a.png";